import React from 'react';

function Settings() {
	return (
		<main className="max-w-7xl mx-auto px-4 py-6">
			<h1 className="text-2xl font-bold text-gray-900 mb-6">Settings</h1>
			<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
				<p className="text-gray-500">No settings configured yet.</p>
			</div>
		</main>
	);
}

export default Settings;
